import { Loader } from '@southfields-digital/mpxlive-components';
import { useLocation, Navigate, Outlet } from 'react-router-dom';

import useAuth, { type Role, RoleEnum } from 'src/hooks/useAuth';

type ProtectedRouteProps = {
  allowedRoles: Role[];
};

const ProtectedRoute = ({ allowedRoles }: ProtectedRouteProps) => {
  const { auth } = useAuth();
  const location = useLocation();

  const getLoginUrl = () => {
    const loginUrl = new URL(
      `${import.meta.env.VITE_SERVICE_AUTH_FRONTEND_URL}/login${location.search}`
    );

    loginUrl.searchParams.set('redirect', window.location.href);

    return loginUrl.toString();
  };

  if (!auth.checked) {
    return <Loader centeredInContainer />;
  }

  if (!auth.authenticated) {
    window.location.href = getLoginUrl();
    return null;
  }

  return auth.roles?.find((role) => role === RoleEnum.Superadmin || allowedRoles.includes(role)) ? (
    <Outlet />
  ) : (
    <Navigate to="/unauthorized" replace state={{ from: location.pathname }} />
  );
};

export default ProtectedRoute;
